var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 72H64C68.4183 72 72 68.4183 72 64V8C72 3.58172 68.4183 0 64 0H8C3.58172 0 0 3.58172 0 8V64C0 68.4183 3.58172 72 8 72Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9985 13C22.746 13 12 23.7871 12 37.0966C12 47.7407 18.876 56.7718 28.4145 59.9584C29.6145 60.1798 30.0525 59.4359 30.0525 58.7973C30.0525 58.2251 30.0315 56.7101 30.0195 54.6996C23.343 56.1559 21.9345 51.4694 21.9345 51.4694C20.844 48.6864 19.2705 47.9455 19.2705 47.9455C17.091 46.4501 19.4355 46.4802 19.4355 46.4802C21.843 46.6504 23.1105 48.9635 23.1105 48.9635C25.2525 52.6455 28.728 51.5823 30.096 50.9649C30.3135 49.4078 30.9345 48.3461 31.62 47.7437C26.2905 47.1353 20.688 45.0691 20.688 35.8362C20.688 33.2053 21.6225 31.0548 23.1585 29.3696C22.911 28.7597 22.0875 26.3111 23.3925 22.9935C23.3925 22.9935 25.4085 22.3459 29.9925 25.4632C31.908 24.9286 33.96 24.662 36.0015 24.6515C38.04 24.662 40.0935 24.9286 42.0105 25.4632C46.5915 22.3459 48.603 22.9935 48.603 22.9935C49.9125 26.3111 49.089 28.7597 48.8415 29.3696C50.3805 31.0548 51.309 33.2053 51.309 35.8362C51.309 45.0917 45.6975 47.1293 40.3515 47.7256C41.2125 48.4696 41.9805 49.9394 41.9805 52.1877C41.9805 55.4089 41.9505 58.0067 41.9505 58.7973C41.9505 59.4419 42.3825 60.1918 43.6005 59.9554C53.13 56.7628 60 47.7377 60 37.0966C60 23.7871 49.254 13 35.9985 13Z",
    fill: "#2F2325"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubff);
export default __webpack_public_path__ + "static/media/githubff.d15352c494b663dcaf107b47b635c7c3.svg";
export { ForwardRef as ReactComponent };